import overloadedNames from "../names/overloadedNames";

// InternalId: Object of {Type, Internal ID}
export default {
  SHIELD: overloadedNames.SHIELD,
};
